import styled from 'styled-components'

import { TickedUnstyled } from 'Components/Ticked/unstyled'

export const Ticked = styled(TickedUnstyled)`
  position: relative;
  display: block;
  width: 100%;
  height: ${props => (props.ticked ? '10px' : '14px')};

  svg {
    position: absolute;
    fill: ${props =>
      props.ticked
        ? props.theme.colors.primary
        : props.theme.colors.regentGray};
    width: 14px;
    height: 100%;
    left: 0;
    right: 0;
    margin: auto;
  }
`
